import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Observable, of } from 'rxjs';

/** Free and disposable mail providers: their domain says nothing about the company. */
const PERSONAL_EMAIL_DOMAINS = new Set([
  'gmail.com', 'googlemail.com', 'outlook.com', 'hotmail.com', 'hotmail.co.uk', 'live.com', 'live.co.uk',
  'msn.com', 'yahoo.com', 'yahoo.co.uk', 'icloud.com', 'me.com', 'mac.com', 'aol.com', 'proton.me',
  'protonmail.com', 'gmx.com', 'mail.com', 'zoho.com', 'yandex.com', 'mailinator.com',
]);

/**
 * What we may send to Brandfetch for a lookup. Never a full email address (third party):
 * an email becomes its company domain, and a personal or disposable mail domain sends nothing.
 * Returns null when there is nothing safe to search for.
 */
export function brandSearchQuery(raw: string | null | undefined): string | null {
  let query = (raw ?? '').trim().replace(/^https?:\/\//i, '');
  if (query.includes('@')) {
    const domain = query.split('@').pop()!.toLowerCase();
    if (!domain || PERSONAL_EMAIL_DOMAINS.has(domain)) {
      return null;
    }
    query = domain;
  }
  return query || null;
}

@Injectable({
  providedIn: 'root'
})
export class BrandFetchService {

  private http = inject(HttpClient);


  brandSearch(domainQuery: string): Observable<BrandSuggestionResponse[]> {

    const query = brandSearchQuery(domainQuery);
    if (!query) {
      return of([]);
    }

    let url = `https://api.brandfetch.io/v2/search/${encodeURIComponent(query)}`

    return this.http.get<BrandSuggestionResponse[]>(url, {
      params: {
        c: `${environment.brandFetch.api_key}`
      }
    });
  }

  getBrandDetails(identifier: string): Observable<any> {
    let url = `https://api.brandfetch.io/v2/brands/${identifier}`

    return this.http.get<any>(url, {
      headers: {
        'Authorization': `Bearer ${environment.brandFetch.api_key}`
      }
    });
  }

}

export interface BrandSuggestionResponse {
  brandId: string;
  claimed: boolean;
  domain: string;
  icon: string;
  name: string;
  qualityScore: number;
  verified: boolean;
  _score: number;
}
